/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import DivorceCosts from "./DivorceCosts";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import PowerOfAttorneyNextSteps from "@/src/components/Form/Common/PowerOfAttorney/PowerOfAttorneyNextSteps";

type PowerOfAttorneyHintBoxProps = {
  product: AbstractCase;
};

export default function PowerOfAttorneyHintBox({ product }: PowerOfAttorneyHintBoxProps) {
  return (
    <HintBox headline={"So geht es weiter"}>
      <PowerOfAttorneyNextSteps bulletPoints={[
        "Wir melden uns umgehend bei Ihnen und Sie können sich flexibel einen Termin für ein anwaltliches Erstgespräch vereinbaren",
        "Das Team rund um Rechtsanwalt Frank Riedel (Fachanwalt für Familienrecht) kümmert sich jederzeit persönlich um Sie",
        "Damit wir Sie vertreten dürfen und Ihren Scheidungsantrag vorbereiten können, benötigen wir Ihre Vollmacht",
        "Wenn alle Fragen geklärt sind, wird der Scheidungsantrag finalisiert und bei Gericht eingereicht",
        "Über den gesamten Prozess werden Sie persönlich von uns begleitet und wir sind bei Fragen selbstverständlich immer für Sie erreichbar",
      ]} />
      <DivorceCosts divorce={product} />
    </HintBox>
  );
}
